(function () {
  function openCartDrawer(event) {
    event.preventDefault();
    const isDrawerEnabled = window.Maximize?.isEnableCartDrawer;
    if (isDrawerEnabled) {
      const cartDrawerEl = document.getElementById('CartDrawer');
      if (cartDrawerEl) {
        cartDrawerEl.isOpen = true;
        document.getElementById('CartDrawer__Wrapper')?.classList.add('is-visible');
        if (cartDrawerEl._isOpenUpsell) {
          const upsellEl = cartDrawerEl.querySelector('cart-drawer-upsell');
          if (upsellEl) {
            cartDrawerEl.removeAttribute('upsell-open');
            upsellEl.isOpen = true;
          }
        }
      }
      return;
    }
    window.location.href = '/cart';
  }

  function bindCartIcon(id) {
    const cartIcon = document.getElementById(id);
    if (!cartIcon || cartIcon.dataset.elitCartBound === 'true') return;

    cartIcon.dataset.elitCartBound = 'true';
    cartIcon.addEventListener('click', openCartDrawer);
    cartIcon.addEventListener('keyup', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        openCartDrawer(event);
      }
    });
  }

  function initCartIcons() {
    bindCartIcon('cart-icon-mobile');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartIcons);
  } else {
    initCartIcons();
  }

  document.addEventListener('shopify:section:load', initCartIcons);
})();
